module.exports = __webpack_public_path__ + "img/logo@3x.1bd3f2e3.png";